import { systemConfigFileList } from '../request';
import addClauseModal from './addClauseModal.vue';
export default {
  components: {
    addClauseModal
  },
  data() {
    return {
      tabs: [{
        tab: '简体中文',
        key: 'zh_CN'
      }, {
        tab: '繁体中文',
        key: 'zh_TW'
      }, {
        tab: '英语',
        key: 'en_US'
      }, {
        tab: '法语',
        key: 'fr_FR'
      }, {
        tab: '西班牙语',
        key: 'es_ES'
      }],
      columns: [{
        slots: {
          title: '序号'
        },
        dataIndex: 'index',
        key: 'index',
        scopedSlots: {
          customRender: 'index'
        },
        align: 'center',
        width: 80
      }, {
        slots: {
          title: '文件名称'
        },
        dataIndex: 'name',
        key: 'name',
        align: 'center'
      }, {
        slots: {
          title: '创建时间'
        },
        dataIndex: 'createAt',
        key: 'createAt',
        align: 'center',
        width: 200
      }, {
        slots: {
          title: '更新时间'
        },
        dataIndex: 'updateAt',
        key: 'updateAt',
        align: 'center',
        width: 200
      }, {
        slots: {
          title: '操作人'
        },
        dataIndex: 'nickName',
        key: 'nickName',
        align: 'center',
        width: 150
      }, {
        slots: {
          title: '操作'
        },
        dataIndex: 'operation',
        key: 'operation',
        align: 'center',
        width: 250,
        scopedSlots: {
          customRender: 'operation'
        }
      }],
      data: [],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      locale: this.$store.state.setting.locale,
      modalVisible: false,
      itemData: null
    };
  },
  computed: {
    language() {
      if (this.locale === 'zh_CN') {
        return 'zh';
      } else if (this.locale === 'zh_TW') {
        return 'cht';
      } else if (this.locale === 'en_US') {
        return 'en';
      } else if (this.locale === 'fr_FR') {
        return 'fra';
      } else if (this.locale === 'es_ES') {
        return 'spa';
      }
    }
  },
  watch: {
    // 监听vuex中的locale
    '$store.state.setting.locale'(val) {
      // 弹框打开的时候不执行
      if (this.modalVisible) return;
      this.locale = val;
      this.getSystemConfigFileList();
    }
  },
  mounted() {
    this.getSystemConfigFileList();
  },
  methods: {
    handleTableChange(val) {
      this.pagination = val;
      this.getSystemConfigFileList();
    },
    languageChange(key) {
      this.locale = key;
      // 重置数据
      this.pagination = {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      };
      this.getSystemConfigFileList();
    },
    async getSystemConfigFileList() {
      let res = await systemConfigFileList({
        language: this.language,
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      });
      this.data = res.items;
      this.pagination.total = res.totalNum;
    },
    handleCli(type, data) {
      if (type === 'preview') {
        // 打开新窗口跳转到预览页面
        let routeData = this.$router.resolve({
          path: `/system/settings/previewPage/${data.id}/${this.language}/2`
        });
        window.open(routeData.href, '_blank');
      } else {
        this.modalVisible = true;
        this.itemData = data || null;
      }
    }
  }
};